export enum AVATAR_SIZES {
  md = 'md',
  sm = 'sm',
  xl = 'xl',
}
